import {Modal} from "react-bootstrap";
import React from "react";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import ModalMsg from "../../../components/ModalMsg";

export default function ModalPermessiView({
                                              show,
                                              handleClose,
                                              translate,
                                              showMsg,
                                              setShowMsg,
                                              modalMsg,
                                              permessiKpi,
                                          }) {

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size={'xl'}
        >
            <Modal.Header
                className={'ns-modal-header'}
                closeVariant='white'
                closeButton>
                <Modal.Title>{translate('Permessi')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalMsg
                    show={showMsg}
                    handleClose={() => setShowMsg(false)}
                    testo={modalMsg}/>
                <div className={"row"}>
                    <div className={"col-md-12"}>
                        <NsDataTable
                            data={permessiKpi}
                            recordPerPagina={15}
                            columns={[
                                {
                                    name: translate('Codice'),
                                    selector: row => row.codice,
                                    sortable: true,
                                },
                                {
                                    name: translate('Descrizione'),
                                    selector: row => row.descrizione,
                                    sortable: true,
                                },
                                {
                                    name: translate('Riferimento'),
                                    selector: row => row.tipo_imp_dati,
                                    sortable: true,
                                },
                                {
                                    name: translate('Macrocategoria'),
                                    selector: row => row.kpi_macrocategoria,
                                    sortable: true,
                                },
                                {
                                    name: translate('Lettura'),
                                    selector: row => <input
                                        type={"checkbox"}
                                        id={'lettura_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                                        className={"form-contorl"}
                                        checked={row.lettura == '1'}
                                        disabled={true}
                                    />,
                                    sortable: false,
                                },
                                {
                                    name: translate('Scrittura'),
                                    selector: row => <input
                                        type={"checkbox"}
                                        id={'scrittura_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                                        className={"form-contorl"}
                                        checked={row.scrittura == '1'}
                                        disabled={true}
                                    />,
                                    sortable: false,
                                },
                                {
                                    name: translate('Approvazione'),
                                    selector: row => <input
                                        type={"checkbox"}
                                        id={'approvazione_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                                        className={"form-contorl"}
                                        checked={row.approvazione == '1'}
                                        disabled={true}
                                    />,
                                    sortable: false,
                                },
                                {
                                    name: translate('Revisione'),
                                    selector: row => <input
                                        type={"checkbox"}
                                        id={'revisione_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                                        className={"form-contorl"}
                                        checked={row.revisione == '1'}
                                        disabled={true}
                                    />,
                                    sortable: false,
                                },
                                {
                                    name: translate('Configurazione'),
                                    selector: row => <input
                                        type={"checkbox"}
                                        id={'configurazione_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                                        className={"form-contorl"}
                                        checked={row.configurazione == '1'}
                                        disabled={true}
                                    />,
                                    sortable: false,
                                }
                            ]}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )

}